import { ApolloClient, ApolloLink, InMemoryCache, NormalizedCacheObject } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { onError } from '@apollo/client/link/error';
import { createUploadLink } from 'apollo-upload-client';

const url = process.env.REACT_APP_CONFIGURATOR_URL;
const httpLink: any = createUploadLink({
    uri: url,
});

const authLink = setContext((_, { headers }) => {
    const userToken = localStorage.getItem('user');
    const token = userToken && JSON.parse(userToken).user.accessToken;
    return {
        headers: {
            ...headers,
            authorization: token ? `Bearer ${token}` : '',
        },
    };
});

const errorLink = onError(({ graphQLErrors, networkError }) => {
    if (graphQLErrors) {
        // eslint-disable-next-line no-console
        graphQLErrors.map(({ message, locations, path }) =>
            console.log(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`),
        );
    }
    if (networkError) {
        // eslint-disable-next-line no-console
        console.log(`[Network error]: ${networkError}`);
    }
});

const link = ApolloLink.from([errorLink, authLink, httpLink]);
const client = new ApolloClient<NormalizedCacheObject>({
    cache: new InMemoryCache(),
    link,
});

export default client;
